<template>
  <div>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64" color="primary" />
    </v-overlay>
    <div v-if="!loading">
      <app-form
        v-bind:parentObject="{
          data: this.formData,
          searchnew: this.search,
          pageTitle: this.pageTitle,
          pageTitleValue: this.pageTitleValue,
          errMsg: this.errMsg,
          isEdit: this.editMode,
        }"
        v-on:input="formData = $event"
        v-on:new="createHandler"
        v-on:save="saveHandler"
        v-on:delete="isConfirm = !isConfirm"
        v-on:error="errorHandler"
      />
  
      <div v-if="isErr">
        <app-error
          v-bind:parentError="{
            data: this.errMsg,
            isErr: this.isErr,
          }"
          v-on:closeError="isErr = $event"
        />
      </div>
  
      <div v-if="isConfirm">
        <app-confirm
          v-bind:parentObject="{
            pageTitleValue: this.pageTitleValue,
            isConfirm: this.isConfirm,
          }"
          v-on:confirm="deleteHandler($event)"
          v-on:cancelConfirm="isConfirm = !isConfirm"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

import ClaimLimitAdjustmentForm from "../../../components/claim/claimlimitadjustment/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";
import ConfirmDialog from "../../../components/common/ConfirmDialog";

export default {
  components: {
    "app-form": ClaimLimitAdjustmentForm,
    "app-error": ErrorDialog,
    "app-confirm": ConfirmDialog,
  },

  data() {
    return {
      id: this.$route.params.id,
      search: this.$route.params.search,
      pageTitle: this.$t('claimlimitadjustmentrecord.editclaimlimitadjustment'),
      pageTitleValue: "",
     // formData: [],     
     formData: {
       staffcode: null,
         staffid: null,
         staffname: null,
         compnyname: null,
         clmtypeid: null,
         clmtypedesc: null,
         clmtype: null,
         clmlimitadjtypeid: null,
         clmlimitadjtype: null,
         adjamount: null,
         valuedate: null,
         clmadjreasonid: null,
         remark: null,
       //  logicscrpt: null,
         stamp: 0,
         userid: this.$store.getters.userId,
       },
     // userid: this.$store.getters.userId,
      loading: true,
      errMsg: "",
      isErr: false,
      isConfirm: false,
      editMode: false,
    };
  },

  methods: {
    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    loadClaimTypeSetup() {
      const vm = this;

      return this.$store.dispatch('get', {url: "/claimlimitadjustment/" + this.id})
        .then((res) => {

          // vm.formData = res.data.rec[0];

          vm.formData.staffcode = res.data.rec[0].staffno;
          vm.formData.compnyname = res.data.rec[0].compnyname;
         // vm.formData.clmlimitadjtypeid = res.data.rec[0].clmlimitadjtypeid;
          vm.formData.clmlimitadjtype = res.data.rec[0].clmlimitadjtype;

           if (res.data.rec[0].valuedate) {
            vm.formData.valuedate = moment(res.data.rec[0].valuedate).format(
              "YYYY-MM-DD"
            );
          }
            
           vm.formData.staffid = res.data.rec[0].staffid;
           vm.formData.clmtypeid = res.data.rec[0].clmtypeid;
           vm.formData.clmtypedesc = res.data.rec[0].clmtypedesc;
           vm.formData.clmtype = res.data.rec[0].clmtype;
           vm.formData.clmlimitadjtypeid = res.data.rec[0].clmlimitadjtypeid;
           vm.formData.adjamount = res.data.rec[0].adjamount;
           vm.formData.clmadjreasonid = res.data.rec[0].clmadjreasonid;
           vm.formData.remark = res.data.rec[0].remark;
       
          // vm.formData.logicscrpt = res.data.rec[0].logicscrpt;
           vm.formData.stamp = res.data.rec[0].stamp;
           vm.pageTitleValue = res.data.rec[0].staffname;
           vm.formData.userid = this.$store.getters.userId;


          vm.loading = false;

          // console.log('clmlimitadjid', payload: this.formData})
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    saveHandler() {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
        return false;
      }

      this.$store.dispatch('put', {url: "/claimlimitadjustment/" + this.id, payload: this.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "claimlimitadjustmentlist", params: { search: this.search}  });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    deleteHandler() {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
        return false;
      }

      this.$store.dispatch('delete', {url:
            "/claimlimitadjustment/" +
            this.id +
            "/" +
            this.formData.userid
        })
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "claimlimitadjustmentlist" });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    createHandler() {
      this.$router.push({ name: "claimlimitadjustmentnew" });
    },
  },

  async mounted() {
    this.editMode = true;
    await this.loadClaimTypeSetup();
  },
};
</script>